<p-toast position="top-right"></p-toast>
@if (isMaintenanceMode()) {
  <app-maintenance></app-maintenance>
} @else {
  <router-outlet></router-outlet>
}
